import React from 'react'
import { mutualTheme } from '~/utils/theme'
import { makeStyles } from '@material-ui/styles'
import { BoxProps, Box } from '@material-ui/core'

const useStyles = makeStyles({
  inputsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    gap: mutualTheme.spacing(2),
    padding: mutualTheme.spacing(3),
    marginTop: mutualTheme.spacing(3),
    borderRadius: mutualTheme.spacing(1),
    boxShadow: '1px 4px 10px rgba(0, 0, 0, 0.05)',
    [mutualTheme.breakpoints.down('md')]: {
      padding: mutualTheme.spacing(2)
    }
  }
})

export const DropInputContainer: React.FC<BoxProps> = (props) => {
  const classes = useStyles()

  return (
    <Box className={classes.inputsContainer}>
      {props.children}
    </Box>
  )
}
